<style>
</style>

<template>
    <div class="animated fadeIn">
        <b-tabs fill>
            <b-tab active>
                <template slot="title">
                    <i class="fa fa-globe mr-2"></i>{{Core.Definition.getDefinition('Langue et localisation')}}
                </template>

                <DynamicForm
                        ref="dynamicForm"
                        getRoot="/setting/environment-local"
                        saveRoot="/setting/environment-local"
                        :formStructure="dataFormStructures.settings">
                </DynamicForm>

            </b-tab>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-globe mr-2"></i>{{Core.Definition.getDefinition('Tâche planifiée')}}
                </template>

                <DynamicForm
                        ref="dynamicForm"
                        getRoot="/setting/environment-crontask"
                        saveRoot="/setting/environment-crontask"
                        :formStructure="dataFormStructures.crontask">
                </DynamicForm>

            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import DynamicForm from '../../../components/DynamicForm'
    export default {
        name: 'SettingsEnvironment',
        components: {
            DynamicForm
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataFormStructures: {
                    settings: {
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'defaultLanguage'
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'timezone'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'multiLingualInstances'
                                            }
                                        ]
                                    },
                                    {}
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'defaultLanguage',
                                type: 'select',
                                label: Core.Definition.getDefinition('Langue par défaut'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'timezone',
                                type: 'select',
                                label: Core.Definition.getDefinition('Timezone'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'multiLingualInstances',
                                type: 'multiSelect',
                                label: Core.Definition.getDefinition('Instances multilingues'),
                                value: null,
                                onSelect: function() {}
                            }
                        ]
                    },
                    crontask: {
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'autoPaymentIsEnabled'
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'completeRecurringSubscriptionIsEnabled'
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'completeExpiredLimitedSubscriptionIsEnabled'
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'resetRecurringSubscriptionBookingLimitIsEnabled'
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'sendMessageIsEnabled'
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'binderPDFIsEnabled'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'autoPaymentIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer les auto-paiements'),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'completeRecurringSubscriptionIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer la complétion des abonnements récurrents'),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'completeExpiredLimitedSubscriptionIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer la complétion des abonnements limités'),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'resetRecurringSubscriptionBookingLimitIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer la réinitialisation des réservations restantes pour les abonnements récurrents'),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'sendMessageIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer l\'envoi des messages'),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'binderPDFIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer la génération PDF'),
                                value: false,
                                onChange: function() {}
                            }
                        ]
                    }
                }
            }
        },
        computed: {
        },
        methods: {
        }
    }
</script>
